import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="bg-[#0F2E23] py-4 md:py-6 px-3 relative border-b border-[#1F3D2B]" data-id="element-202">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-203">
        <div className="inline-block bg-[#071A14] border border-[#D4A843] text-[#D4A843] font-black px-3 py-1 rounded-full mb-2 uppercase tracking-widest text-[10px] md:text-xs shadow-lg" data-id="element-204">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-205">
          🔥 KIT COMPLETO{' '}
          <span className="text-[#D4A843]" data-id="element-206">GEOGRAFÍA RURAL LISTA</span>
        </h2>

        <p className="text-sm md:text-base text-[#BFC9C5] font-bold mb-3 max-w-xl mx-auto leading-snug" data-id="element-207">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas con seguridad.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 max-w-2xl mx-auto mb-3 text-left" data-id="element-208">
          {[{
          text: '6 tomos completos (480 págs)',
          icon: '✔'
        }, {
          text: 'Geografía productiva, ambiental y agraria',
          icon: '✔'
        }, {
          text: 'Actividades y proyectos listos',
          icon: '✔'
        }, {
          text: 'Evaluaciones completas',
          icon: '✔'
        }, {
          text: 'Sistema estructurado',
          icon: '✔'
        }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#071A14] border border-[#1F3D2B] p-2 rounded-lg" data-id="element-209">
              <span className="text-[#74C69D] text-sm flex-shrink-0 font-black" data-id="element-210">
                {item.icon}
              </span>
              <span className="text-[#BFC9C5] font-bold text-xs md:text-sm leading-tight" data-id="element-211">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="bg-[#102A1F] rounded-lg p-2 inline-block mb-4 w-full max-w-lg border border-[#D4A843]/50" data-id="element-212">
          <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-213">
            👉 Todo organizado para que solo tengas que enseñar.
          </p>
          <p className="text-[#BFC9C5] font-bold text-xs mt-1" data-id="element-214">
            👉 Abrís el material… 👉 y ya sabés exactamente qué dar.
          </p>
        </div>
      </div>
    </section>;
}